import {
    bbsDistrictLoad
} from "../../services/api/bbs-district";
import {
    UPDATE_ADDRESS_LIST
} from "../mutation-types";

export default async function loadDistricts({
    commit
}, pid) {
    pid = pid > 0 ? +pid : 0
    const args = pid > 0 ? {
        id: pid
    } : {}
    const {
        list
    } = await bbsDistrictLoad(args)
    commit(UPDATE_ADDRESS_LIST, {
        list,
        pid
    })
    return {
        list,
        pid
    }
}
